<template>
  <div class="el-input el-input-group el-input-group--append el-input--small wsearch">
    <input
      class="el-input__inner"
      ref="input"
      clearable
      :style="[width,!showButton?border:'']"
      :value="searchKey" 
      :placeholder="$t('placeholder.search')"
      @input="handleInput"
      @clear="handleClear"
      @keyup.delete="handelDelete(searchKey)"
      @keyup.enter="handelSearch(searchKey)" />    
      <i class="el-icon-circle-close" @click="handleClear" v-if="!!searchKey.length"></i>    
      <div class="el-input-group__append" v-if="showButton" >      
        <el-button 
          slot="append" 
          :loading="loading" 
          :icon="value===''||value===undefined?'el-icon-refresh':'el-icon-search'" 
          @click="handelSearch(searchKey)">
        </el-button>      
      </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showButton: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '100%'
    },
    value: [String, Number]
  },
  data() {
    return {
      searchKey: this.value,
      border: {
        'border-radius': '3px'
      }
    }
  },
  methods: {
    handelSearch(key) {
      this.$emit('handelSearch', key)
    },
    handelDelete(key) {
      if (key === '') {
        this.$emit('handelDelete', key)
      }
    },
    handleInput(event) {
      const value = event.target.value
      this.searchKey = value
      this.$emit('input', value) // key code
    },
    filterClean() {
      this.searchKey = ''
      this.$emit('input', '')
    },
    handleClear() {
      this.searchKey = ''
      this.$emit('input', '')
      this.$emit('handleClear') // key code
    }
  }
}
</script>
<style lang="scss">
  .wsearch{
    position: relative;
    .el-icon-circle-close{
      position: absolute;
      top: 0;
      z-index: 999;
      top:50%;
      margin-top: -6.5px;
      opacity: 0.6;
      right:0px;
      cursor: pointer;
    }
  }
</style>


